import { Link } from 'react-router-dom';
import { PageHero } from '../components/ui/PageHero';
import { AnimatedCard } from '../components/ui/AnimatedCard';
import { CTAButton } from '../components/ui/CTAButton';
import { InquiryForm } from '../components/ui/InquiryForm';
import { PRODUCTS, PURCHASE_PROCESS, PURCHASE_FAQ } from '../constants/content';
import { inquiryPath } from '../constants/navigation';

export default function InquiryPage() {
  return (
    <>
      <PageHero
        title="购买咨询"
        subtitle="无论是零售购买、企业礼品还是批量定制，填写意向即可获取专属报价与方案。"
        breadcrumb={[{ label: '首页', path: '/' }, { label: '购买咨询' }]}
      />

      <section className="container mx-auto px-4 py-16">
        <div className="max-w-5xl mx-auto mb-16">
          <h2 className="text-2xl font-bold text-center mb-8">选择意向产品</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {PRODUCTS.map((product) => (
              <Link
                key={product.slug}
                to={inquiryPath(product.slug)}
                className="link-card bg-white/5 rounded-2xl border border-purple-500/20 overflow-hidden group"
              >
                <div className="aspect-square bg-darker/50 flex items-center justify-center p-6">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="max-h-full object-contain group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="font-semibold mb-1 group-hover:text-secondary transition-colors">
                    {product.title}
                  </h3>
                  <p className="text-purple-400 text-xs mb-2">{product.priceNote}</p>
                  <p className="text-purple-300 text-sm">{product.moq}</p>
                  <span className="inline-flex items-center text-secondary text-sm mt-3 font-medium">
                    立即咨询 <i className="fa fa-arrow-right ml-2 text-xs" />
                  </span>
                </div>
              </Link>
            ))}
            <Link
              to={inquiryPath('general')}
              className="link-card bg-gradient-to-br from-primary/20 to-secondary/20 rounded-2xl border border-purple-500/30 p-8 flex flex-col justify-center items-center text-center group min-h-[280px]"
            >
              <i className="fa fa-envelope-o text-4xl text-secondary mb-4 group-hover:scale-110 transition-transform" />
              <h3 className="font-semibold mb-2">通用咨询</h3>
              <p className="text-purple-300 text-sm mb-4">不确定选哪款？提交通用咨询，我们为您推荐</p>
              <span className="text-secondary text-sm font-medium">前往填写 →</span>
            </Link>
          </div>
        </div>

        <div className="max-w-3xl mx-auto mb-16">
          <h2 className="text-2xl font-bold text-center mb-8">采购流程</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {PURCHASE_PROCESS.map((item) => (
              <AnimatedCard
                key={item.step}
                className="flex gap-4 bg-white/5 rounded-xl p-5 border border-purple-500/20"
              >
                <span className="w-10 h-10 rounded-full bg-primary/30 flex items-center justify-center font-bold shrink-0">
                  {item.step}
                </span>
                <div>
                  <h3 className="font-semibold mb-1">{item.title}</h3>
                  <p className="text-purple-300 text-sm">{item.desc}</p>
                </div>
              </AnimatedCard>
            ))}
          </div>
        </div>

        <div className="max-w-2xl mx-auto mb-16">
          <h2 className="text-2xl font-bold text-center mb-8">快速咨询</h2>
          <AnimatedCard className="bg-white/5 rounded-2xl p-8 border border-purple-500/20">
            <InquiryForm subject="Ameowzing 购买咨询" />
          </AnimatedCard>
        </div>

        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl font-bold text-center mb-6">采购常见问题</h2>
          <div className="space-y-3">
            {PURCHASE_FAQ.map((item) => (
              <details
                key={item.q}
                className="group bg-white/5 rounded-xl border border-purple-500/20 overflow-hidden"
              >
                <summary className="cursor-pointer p-4 font-medium text-sm hover:bg-white/5 list-none flex justify-between">
                  {item.q}
                  <i className="fa fa-chevron-down text-purple-400 group-open:rotate-180 transition-transform" />
                </summary>
                <p className="px-4 pb-4 text-purple-300 text-sm">{item.a}</p>
              </details>
            ))}
          </div>
        </div>

        <div className="text-center mt-12 flex flex-wrap gap-4 justify-center">
          <CTAButton to="/products" variant="secondary" icon="fa-cube">
            浏览产品详情
          </CTAButton>
          <CTAButton to="/contact/gift" variant="outline" icon="fa-gift">
            礼品批量采购
          </CTAButton>
        </div>
      </section>
    </>
  );
}
